import React from 'react';
import EmailLogin from './EmailLogin';

const Login: React.FC = () => {
  const handleLoginSuccess = () => {
  };

  return (
    <EmailLogin onSuccess={handleLoginSuccess} />
  );
};

export default Login;
